module.exports = __webpack_public_path__ + "static/media/back.1164e17e.svg";